<template>
  <div class="container pull-up">
    <div class="row">
      <div class="col-md-12">
        <div class="card m-b-30">
          <div class="card-header">
            <el-row>
              <el-col :span="12">
                <h5 class="m-b-0">
                  <i class="mdi mdi-security-network"></i> {{ $t('role.permission.title') }}
                </h5>
              </el-col>
            </el-row>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <data-tables
                :data="permissions.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
                :pagination-props="{ pageSizes: [10, 15, 30, 40, 100], pageSize: 10 }"
                center-align>
                <el-table-column prop="name" :label="$t('permission.label.name')" fixed></el-table-column>
                <el-table-column prop="guard_name" :label="$t('permission.label.guard')" fixed></el-table-column>
                <el-table-column prop="created_at" :formatter="$shortDate" :label="$t('label.created')"
                                 sortable></el-table-column>
                <el-table-column prop="updated_at" :formatter="$shortDate" :label="$t('label.last_updated')"
                                 sortable></el-table-column>
                <el-table-column label="Actions" min-width="120px">
                  <template slot="header" slot-scope="scope">
                    <el-input v-model="search" size="mini" autofocus
                              :placeholder="$t('text.search_placeholder')"/>
                  </template>
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-tooltip :content="$t('permission.button.view_roles')">
                        <el-button size="mini" type="info" icon="el-icon-view"
                                   @click="viewPermissionRoles(scope.row)">
                          {{ $t('button.view_roles') }}
                        </el-button>
                      </el-tooltip>
                    </el-button-group>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Permissions',
  data () {
    return {
      permissions: [],
      search: '',
      loading: false
    }
  },
  methods: {
    viewPermissionRoles (permission) {
      // Show roles that have this permission
      this.$message.info(`Permission "${permission.name}" is assigned to roles.`)
    },
    async loadPermissions () {
      try {
        await this.withLoading(async () => {
          this.permissions = await this.$permissionService.getPermissions()
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in loadPermissions:', error)
      }
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('role.permission.title'))
    await this.loadPermissions()
  }
}
</script>

<style scoped>

</style>
